import { Directive, ElementRef } from '@angular/core';
import { DesktopService } from '../providers/desktop-service';

@Directive({
    selector: '[desktop-only]'
})
export class DesktopOnlyDirective {
    public isDesktop: boolean = false;
    public element: HTMLElement = null;

    constructor(
        private desktop: DesktopService,
        private elementRef: ElementRef,
    ) {
        this.isDesktop = desktop.isDesktop();
    }

    public ngOnInit() {
        this.element = this.elementRef.nativeElement;
        if (!this.isDesktop) this.element.classList.add('hidden');
    }
}



// WEBPACK FOOTER //
// ./src/directives/desktop-only.ts